import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import {
  useAppDispatch,
  useAppSelector,
} from '../../../../App/Hooks/reduxHooks'
import { ISurveyQuestion } from '../../Client/ISurvey'
import { getSurveys } from '../../Store/Action'
import { ReadDescriptionCard, ReadQuestionCard } from '../Components'

import { Layout } from './Layout'

export const PreviewSurvey = () => {
  const dispatch = useAppDispatch()
  const [questions, setQuestions] = useState<ISurveyQuestion[]>([])

  const { surveyId } = useParams<{ surveyId: string }>()

  const survey = useAppSelector(state =>
    state.customers.surveys.list.find(oneSurvey => oneSurvey.id === surveyId),
  )

  useEffect(() => {
    if (survey && survey.questions) {
      setQuestions(survey.questions)
    } else if (typeof survey === 'undefined') {
      dispatch(getSurveys())
    }
  }, [survey])

  return (
    <Layout>
      <div>
        <ReadDescriptionCard
          surveyTitle={survey && survey.name}
          surveyDescription={survey && survey.description}
        />

        {questions &&
          questions
            .sort((qA, qB) => qA.order - qB.order)
            .map((question, index) => {
              const cardId = question.id
              return (
                <ReadQuestionCard
                  key={cardId}
                  id={cardId}
                  question={question.question}
                  type={question.type}
                  isMultiline={question.isMultiline}
                  isMultipleChoice={question.isMultipleChoice}
                  order={index}
                  choices={question.choices}
                />
              )
            })}
      </div>
    </Layout>
  )
}
